import { DEFAULT_NAMESPACE } from '@appfolio/backstage-plugin-catalog-common';

export const ANNOTATION_DEPLOYMENT_REGEX =
  'appfolio.com/service-deployment-regex';

export const ENTITY_REF_DEPLOYMENTS_AWS = `system:${DEFAULT_NAMESPACE}/aws-based-service-deployments`;
export const ENTITY_REF_DEPLOYMENTS_ADEP = `component:${DEFAULT_NAMESPACE}/adep-app`;
export const ENTITY_REF_DEPLOYMENTS_CDEP = `component:${DEFAULT_NAMESPACE}/cdep`;

export const RELATION_DEPLOYED_BY = 'deployedBy';
export const RELATION_DEPLOYER_OF = 'deployerOf';
